import { ILineItem } from '@/src/modules/cart/ICart'
import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'

export function isMilitaryBaseAddressWithMultiplePlastics({
    lineItems,
    state,
}: {
    lineItems: ILineItem[]
    state: string
}) {
    const plasticCount: number = lineItems?.filter(
        (item: ILineItem) =>
            item.product.resolved_data.product_medium.medium_type ===
            MEDIUM_TYPE_PHYSICAL
    ).length

    return state === 'AA' && plasticCount > 1
}
